import { Button } from '@/components/Button';
import { Form } from '@/components/Form';
import { Flex } from '@/components/Grid';
import { Heading } from '@/components/Heading';
import { Link } from '@/components/Link';
import { Text } from '@/components/Text';
import { type AdType } from '@/resource/ad';
import { CancelLink } from './CancelLink';

type Props = {
  adType: AdType;
  useGeneratedTitle: boolean;
  setuseGeneratedTitle: (use: boolean) => void;
  onNext: () => void;
};

export function SelectTitleTypeForm({
  adType,
  useGeneratedTitle,
  setuseGeneratedTitle,
  onNext,
}: Props) {
  const label = adType === 'offer' ? 'aanbod' : 'vraag';

  return (
    <Form
      onSubmit={(e) => {
        e.preventDefault();
        onNext();
      }}
    >
      <Flex dir="column" gap={4}>
        <Heading visualLevel={3} align="center">
          Plaats jouw {label}
        </Heading>

        <Text>
          <strong>Let op!</strong> Als je hulp nodig hebt{' '}
          <Link to={{ type: 'add_request' }} underline>
            plaats dan een vraag
          </Link>
          .
        </Text>
        <Text>
          Kies hieronder of je de tekst zelf wilt schrijven, of dat je wilt
          kiezen uit een lijst met activiteiten.
        </Text>

        <Flex dir="column" gap={2}>
          <Flex align="center">
            <input
              type="radio"
              name="use_dynamic_title"
              id="use_dynamic_title"
              value={0}
              checked={!useGeneratedTitle}
              onChange={() => setuseGeneratedTitle(false)}
            />
            <label htmlFor="use_dynamic_title">
              Ik schrijf mijn aanbod zelf
            </label>
          </Flex>
          <Flex align="center">
            <input
              type="radio"
              name="use_dynamic_title"
              id="use_activities"
              value={1}
              checked={useGeneratedTitle}
              onChange={() => setuseGeneratedTitle(true)}
            />
            <label htmlFor="use_activities">
              Ik kies uit een lijst activiteiten
            </label>
          </Flex>
        </Flex>

        <Flex justify="end">
          <Button
            type="submit"
            icon="chevron_right_narrow"
            iconPosition="right"
            iconSize={2}
          >
            {useGeneratedTitle ? 'Naar locatie' : 'Naar omschrijving'}
          </Button>
        </Flex>

        <CancelLink adType={adType} />
      </Flex>
    </Form>
  );
}
